export default [
  {
    path: 'content/:id',
    getComponent(location, callback) {
      import('./containers/StaticContentPage').then(component => callback(null, component.default));
    },
  },
];
